export function formatError(err: unknown): string {
  const ax = err as { response?: { data?: { detail?: string; title?: string } } }
  return ax.response?.data?.detail ?? ax.response?.data?.title ?? 'Błąd zapisu'
}

export const STAGE_CODE_REGEX = /^[A-Z][A-Z0-9_]{0,63}$/
